import { render } from "./BeneficiaryBadge.vue?vue&type=template&id=e5d10eee"
import script from "./BeneficiaryBadge.vue?vue&type=script&lang=js"
export * from "./BeneficiaryBadge.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__